import { MARKET_FEEDER_MODES } from 'modules/LiveData/constants';
import { ChangeModeSubscriptionData } from './typings';

export const DEFAULT_CHANGE_MODE_INSTRUMENT_KEYS: ChangeModeSubscriptionData = {
  [MARKET_FEEDER_MODES.LTPC]: [],
  [MARKET_FEEDER_MODES.OPTION_CHAIN]: [],
  [MARKET_FEEDER_MODES.FULL]: [],
  [MARKET_FEEDER_MODES.FULL_D30]: [],
  [MARKET_FEEDER_MODES.FULL_SR]: [],
};
